<app-options-select
  [options]="options()"
  [value]="displayValue()"
  (valueChange)="onValueChange($event)"
  [disabled]="disabled()"
  placeholder="provider.tenderResponse.subcriteriaAttributes.selectFulfillmentScore"
  [testId]="'attribute-ternary-' + testIdKey()"
  styleClass="w-40"
/>
